var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F6F7FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.614 10.1988C20.2814 9.8662 19.7442 9.8662 19.386 10.1988L9 19.8174L10.2279 21.122L11.3023 20.1243V29.1546C11.3023 29.6406 11.7116 30.0499 12.1977 30.0499H27.8023C28.2884 30.0499 28.6977 29.6406 28.6977 29.1546V20.1499L29.7721 21.1476L31 19.8429L20.614 10.1988ZM20 27.3895C16.7767 27.3895 14.1674 24.7802 14.1674 21.5569C14.1674 18.3336 16.7767 15.7243 20 15.7243C23.2233 15.7243 25.8326 18.3336 25.8326 21.5569C25.8326 24.7802 23.2233 27.3895 20 27.3895Z",
    fill: "#4B9BF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8888 20.6624V18.5135H19.0981V20.6624H16.9492V22.4531H19.0981V24.6019H20.8888V22.4531H23.0376V20.6624H20.8888Z",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinic);
export default __webpack_public_path__ + "static/media/Clinic.3d92a56de4e450a2a4d9cc77e1796835.svg";
export { ForwardRef as ReactComponent };